module.exports = "/_next/static/images/whistle_blowing_system-2b2b21347c529e6aee87396e5f070d67.png";